import store from '@/store/store';
import { PGetAllAnonymeWithLiensInferieursAsync } from '@/api/tiers';
import { TYPE_CLIENT, SOUS_TYPE_AUCUN } from '@/configurations/clientConf';
import { getAllPdvIdsTiers } from '@/services/gestionTiers/getPdv';

export default async function getAllTiersIdsInUser(user) {
  const hash = store.getters['user/hash'];
  const tiersId = user.extend.tiersId || [];
  const groupeIds = user.extend.groupeIds || [];
  const enseigneIds = user.extend.enseigneIds || [];
  const payload = { sousType: [SOUS_TYPE_AUCUN], type: TYPE_CLIENT };
  const payloads = [
    ...groupeIds.map((id) => ({ ...payload, tiersId: id })),
    enseigneIds.length ? { ...payload, enseigneIds } : null,
  ].filter(Boolean);
  if (payloads.length) {
    const response = await Promise.all(payloads.map(async (p) => {
      const res = await PGetAllAnonymeWithLiensInferieursAsync(hash, p);
      return res.data.result.items;
    }));
    tiersId.push(...response.flat().flatMap(getAllPdvIdsTiers));
  }
  return tiersId;
}
